"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardDemo = void 0;
const routeIds_1 = require("root/src/shared/descriptions/routes/routeIds");
const auth_1 = require("root/src/shared/constants/auth");
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const currentRouteObj_1 = __importDefault(require("root/src/client/logic/route/selectors/currentRouteObj"));
const demoDashboard_constants_1 = require("root/src/shared/demoDashboard/demoDashboard.constants");
const demoDashboard_routes_1 = require("root/src/shared/demoDashboard/demoDashboard.routes");
const demoGetDropEventPayload = {
    endpointId: demoDashboard_constants_1.demoDashboardEndpointIds.DEMO_GET_DASHBOARD_DROP_EVENT,
    payload: (state) => {
        const { routeParams: { recordId }, } = (0, currentRouteObj_1.default)(state);
        return { recordId };
    },
};
exports.dashboardDemo = {
    [routeIds_1.DEMO_CAMPAIGN_DASHBOARD_ROUTE_ID]: {
        url: demoDashboard_routes_1.demoDashboardRoutes.campaign(),
        makeRequestsOnClient: true,
        noSitemap: true,
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.brand,
        defaultRouteId: routeIds_1.LOGIN_ROUTE_ID,
        serverSideRequests: [
            demoGetDropEventPayload,
        ],
        modules: [
            moduleIds_1.DEMO_GRAPHS_DASHBOARD_MODULE_ID,
        ],
    },
    [routeIds_1.DEMO_CAMPAIGN_CREATORS_ROUTE_ID]: {
        url: demoDashboard_routes_1.demoDashboardRoutes.creators(),
        makeRequestsOnClient: true,
        noSitemap: true,
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.brand,
        defaultRouteId: routeIds_1.LOGIN_ROUTE_ID,
        serverSideRequests: [
            demoGetDropEventPayload,
        ],
        modules: [
            moduleIds_1.DEMO_CAMPAIGN_CREATORS_MODULE_ID,
        ],
    },
    [routeIds_1.DEMO_CAMPAIGN_CLIPS_ROUTE_ID]: {
        url: demoDashboard_routes_1.demoDashboardRoutes.clips(),
        makeRequestsOnClient: true,
        noSitemap: true,
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.brand,
        defaultRouteId: routeIds_1.LOGIN_ROUTE_ID,
        serverSideRequests: [
            demoGetDropEventPayload,
        ],
        modules: [
            moduleIds_1.DEMO_CAMPAIGN_CLIPS_LIST_MODULE,
        ],
    },
};
